module.exports = __webpack_public_path__ + "static/live-chat.4ab0be39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/live-chat.svg
// module id = 461
// module chunks = 35783957827783